import { Button, Content, Flex, StrokeIcon, StrokeIconName } from '@acsbe/ui';
import React from 'react';

interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
  iconName?: StrokeIconName;
  iconScale?: 'danger' | 'warning' | 'success' | 'base';
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  message,
  onDismiss,
  iconName = 'ExclamationMarkWithCircle',
  iconScale = 'danger',
}) => (
  <Flex
    row
    align="center"
    justify="space-between"
    gap={2}
    paddingInline={2}
    paddingBlock={2}
    radius="md"
    variant="static"
    scale={iconScale}
  >
    <Flex row align="center" gap={2}>
      <StrokeIcon name={iconName} />
      <Content scale="base" variant="elementActive">
        {message}
      </Content>
    </Flex>
    <Button
      variant="tertiary"
      aria-label="Dismiss error"
      data-mixpanel="dismiss-error"
      onClick={onDismiss}
    >
      <StrokeIcon name="Trash" />
    </Button>
  </Flex>
);
